import React from "react";
import {
    Dialog,
    DialogContent,
    Typography,
    Button,
    IconButton,
    Box,
    styled,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const StyledDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiPaper-root": {
        backgroundColor: "rgb(13, 32, 63)",
        color: "#ffffff",
        borderRadius: "12px",
        maxWidth: "520px",
        width: "100%",
        padding: theme.spacing(2.5),
        position: "relative",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.5)",
    },
}));

const PrimaryButton = styled(Button)({
    backgroundColor: "#3f69f8",
    color: "#ffffff",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.875rem",
    padding: "6px 16px",
    borderRadius: "6px",
    "&:hover": {
        backgroundColor: "#2b52d9",
    },
});

export default function UserManualMarketingPopup({
    open,
    onClose,
    onOpenManual,
}) {
    const handleExplore = () => {
        onClose?.();
        onOpenManual?.();
    };

    return (
        <StyledDialog
            open={Boolean(open)}
            onClose={onClose}
            aria-labelledby="user-manual-dialog-title"
        >
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: "absolute",
                    right: 12,
                    top: 12,
                    color: "rgba(255, 255, 255, 0.6)",
                    "&:hover": {
                        color: "#ffffff",
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                    },
                }}
            >
                <CloseIcon />
            </IconButton>

            <DialogContent sx={{ p: 1 }}>
                <Typography
                    variant="caption"
                    sx={{
                        color: "rgba(255, 255, 255, 0.6)",
                        fontWeight: 500,
                        fontSize: "0.8rem",
                        display: "block",
                        mb: 0.5,
                    }}
                >
                    Go deeper
                </Typography>

                <Typography
                    id="user-manual-dialog-title"
                    variant="h6"
                    component="h2"
                    sx={{ fontWeight: 700, mb: 1.5, pr: 3, color: "#ffffff" }}
                >
                    Want to go deeper?
                </Typography>

                <Typography
                    variant="body2"
                    sx={{
                        color: "rgba(255, 255, 255, 0.85)",
                        mb: 3,
                        lineHeight: 1.6,
                        fontSize: "0.9rem",
                    }}
                >
                    The User Manual explains the chart settings, controls and
                    calculations behind the tools available in Free. You can
                    open it anytime from the top-right menu.
                </Typography>

                <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                    <PrimaryButton onClick={handleExplore}>
                        Open User Manual →
                    </PrimaryButton>
                </Box>
            </DialogContent>
        </StyledDialog>
    );
}
